(function () {
  var CONFIG = {
    brandColor: '#FF63AB',
    email: 'service@whoopea.com',
    trackUrl: 'https://t.17track.net/en#nums=',
    shippingPolicyUrl: 'https://whoopea.shop/pages/shipping-fee-and-free-shipping-policy',
    privacyUrl: '/policies/privacy-policy',
    welcomeOnline:
      'Hi there 👋\nThis is not a live agent window.\nIf you need any support, please contact us on\nEmail: service@whoopea.com\nWe will reply you in 24 hours 🥰',
    welcomeOffline:
      'Hi there 👋\n\nIf you need any support, please contact us on\n\nE-mail: service@whoopea.com\n\nWe will reply you in 24 hours 🥰',
    preChatDescription: 'Please enter your contact information so we can keep you updated with our replies',
    quickReplies: [
      {
        question: 'How to track my order',
        answer:
          'After we upload the tracking number, you will receive an email from our system about your tracking number, please click the tracking number to go to the carrier website for the tracking.\n\nAlso, you can click: Chat - Order Tracking - Enter Order Info to tracking your order.',
      },
      {
        question: 'How long will it take to receive my order?',
        answer:
          'It takes 72 hours for us to ship out your order and usually 7-14 business days to receive your order after we shipped out. We’re doing our best to deliver it promptly for you.',
      },
    ],
    faqs: [
      {
        q: 'How long will it take to receive my order?',
        a: 'It takes 72 hours for us to ship out your order and usually 7-14 business days to receive your order after we shipped out. We’re doing our best to deliver it promptly for you.',
      },
      {
        q: 'How to track my order?',
        a: 'After we upload the tracking number, you will receive an email from our system about your tracking number, please click the tracking number to go to the carrier website for the tracking.\n\nAlso, you can click: Chat with us - Order Tracking - Enter Order Info to tracking your order.',
      },
      {
        q: 'Do you ship to my country?',
        a: 'Yes, we do world-wide shipping, we have a powerful shipping resource and able to ship to any country and region in the world.',
      },
      {
        q: 'Is it 100% authentic and original?',
        a: 'Yes, every blind box and figures in our website is 100% authentic and original. We are a wholesaler and retailer for blind box and have a 4000 Square Feet warehouse based in China, our supply chain is verified and original. We also have legal license to sell these products.',
      },
      {
        q: 'How can I purchase a confirmed design?',
        a: 'We have confirmed design options for certain products, if the one you want to order is not listed as confirmed design in the product link, you can also contact us by Email to ask if we can list them for you. But this is NOT guaranteed.',
      },
      {
        q: 'How much for shipping fee?',
        a: 'To learn more about our shipping fee, please click <a href="https://whoopea.shop/pages/shipping-fee-and-free-shipping-policy" target="_blank" rel="noopener noreferrer">learn more</a>',
        html: true,
      },
      {
        q: 'How do I contact customer service?',
        a: 'Please contact us on E-mail: service@whoopea.com, this is our only customer service window.\n\nPlease leave your order number if you have questions after you ordered.\n\nWe will reply you in 24 hours :)',
      },
      {
        q: 'Do I need to pay tariffs?',
        a: "No, after you ordered in our website, there won't be any extra charges of tariffs or tax, we will cover it all. No matter which country you are in, we will make sure ship to your address without any tariffs.",
      },
      {
        q: 'What would the condition be like for confirmed design?',
        a: "The confirmed design is box pre-opened. otherwise we won't know what's inside. but the plastic bag is still factory-sealed. the doll is intact inside. we pre-open the box just for confirming item with the tag card.",
      },
    ],
  };

  function init() {
    var root = document.getElementById('WhoopeaServiceWidget');
    if (!root) return;

    var launcher = root.querySelector('.whoopea-service__launcher');
    var closeBtn = root.querySelector('.whoopea-service__close');
    var navButtons = root.querySelectorAll('.whoopea-service__nav-btn');
    var tabPanels = root.querySelectorAll('.whoopea-service__tab-panel');
    var quickReplies = root.querySelector('#WhoopeaServiceQuickReplies');
    var homeAnswer = root.querySelector('#WhoopeaServiceHomeAnswer');
    var messageForm = root.querySelector('#WhoopeaServiceMessageForm');
    var trackForm = root.querySelector('#WhoopeaServiceTrackForm');
    var faqList = root.querySelector('#WhoopeaServiceFaqList');
    var contactEmail = root.querySelector('#WhoopeaServiceContactEmail');

    buildQuickReplies(quickReplies, homeAnswer);
    buildFaqs(faqList);

    if (contactEmail) {
      contactEmail.href = 'mailto:' + CONFIG.email;
      contactEmail.textContent = CONFIG.email;
    }

    launcher.addEventListener('click', function () {
      root.classList.toggle('is-open');
      document.body.classList.toggle('whoopea-service-open', root.classList.contains('is-open'));
    });

    closeBtn.addEventListener('click', closeWidget);

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.dataset.tab;
        navButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        tabPanels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.tab === tab);
        });
      });
    });

    messageForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = messageForm.querySelector('[name="email"]').value.trim();
      if (!email) return;
      window.location.href =
        'mailto:' +
        CONFIG.email +
        '?subject=' +
        encodeURIComponent('Customer support request') +
        '&body=' +
        encodeURIComponent('My email: ' + email + '\n\n');
    });

    trackForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var tracking = trackForm.querySelector('[name="tracking_number"]').value.trim();
      if (!tracking) return;
      window.open(CONFIG.trackUrl + encodeURIComponent(tracking), '_blank', 'noopener,noreferrer');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeWidget();
    });

    function closeWidget() {
      root.classList.remove('is-open');
      document.body.classList.remove('whoopea-service-open');
    }
  }

  function buildQuickReplies(container, answerBox) {
    if (!container) return;
    CONFIG.quickReplies.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'whoopea-service__quick-reply';
      btn.textContent = item.question;
      btn.addEventListener('click', function () {
        answerBox.hidden = false;
        answerBox.textContent = item.answer;
      });
      container.appendChild(btn);
    });
  }

  function buildFaqs(container) {
    if (!container) return;
    CONFIG.faqs.forEach(function (item, index) {
      var wrap = document.createElement('div');
      wrap.className = 'whoopea-service__faq-item';

      var question = document.createElement('button');
      question.type = 'button';
      question.className = 'whoopea-service__faq-question';
      question.textContent = item.q;
      question.addEventListener('click', function () {
        wrap.classList.toggle('is-open');
      });

      var answer = document.createElement('div');
      answer.className = 'whoopea-service__faq-answer';
      if (item.html) answer.innerHTML = item.a;
      else answer.textContent = item.a;

      wrap.appendChild(question);
      wrap.appendChild(answer);
      container.appendChild(wrap);

      if (index === 0) wrap.classList.add('is-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
